import { FC, useState } from "react"
import { parseCNPJ, parseCPF } from "src/framework/commons/masks";
import { ChangeValue, CustomTextField } from "../InputParameters";
import { InputText, InputTextParameters } from "../InputText"
import { ValidateUtil } from "src/framework/commons/ValidateUtil";
export interface InputCPFCNPJProperties extends InputTextParameters, CustomTextField {

}

const InputCPFCNPJ: FC<InputCPFCNPJProperties> = ({
    onChangeValue,
    fullWidth = true,
    ...props
}) => {
    const [withError, setWithError] = useState<boolean>(false); 
    return (
        <InputText
            {...props}
            fullWidth={fullWidth}
            mask="cpf_cnpj"
            onChange={(e: any) => {
                if (props.onChange) {
                    props.onChange(e)
                }

                if (onChangeValue) {
                    const val = e.target.value;
                    const withLetters = /[a-zA-Z]/.test(val);
                    const onlyNumber = val?.replace(/[^0-9]/g, '');

                    const newValue: ChangeValue = {
                        value: (onlyNumber.length <= 11 && !withLetters) ? parseCPF(val) : parseCNPJ(val),
                        numberValue: Number(val.replace(/\D/g, ".")),
                        name: props?.name ? props.name : null
                    }

                    onChangeValue(newValue)
                }
            }}
            error={withError}
            onBlur={(e: any) => {
                const value = e.target.value;
                const withLetters = /[a-zA-Z]/.test(value);
                const onlyNumber = value?.replace(/[^0-9]/g, '');
                const valid = (onlyNumber.length <= 11 && !withLetters) ? ValidateUtil.isValidCPF(value) : ValidateUtil.isValidCNPJ(value);
                if (value) {
                    setWithError(!valid);
                }
            }}
        />
    );
}

export { InputCPFCNPJ }